import { render } from "./TopBarSecureMessageBody.vue?vue&type=template&id=59993439"
import script from "./TopBarSecureMessageBody.vue?vue&type=script&lang=js"
export * from "./TopBarSecureMessageBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__